export default __webpack_public_path__ + "static/media/3180.0c1e267b.svg";